/**
 * FloatingUserMenu 아이콘 컴포넌트
 * 
 * CSS currentColor를 사용하여 부모 요소의 color를 상속받습니다.
 * hover 효과는 CSS에서 처리됩니다.
 */
import React from 'react';

// 공통 아이콘 props - stroke는 currentColor로 통일
const defaultProps = {
    width: "15",
    height: "15",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

// 홈 아이콘
export const HomeIcon = () => (
    <svg {...defaultProps}>
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9,22 9,12 15,12 15,22" />
    </svg>
);

// 설정 아이콘
export const SettingsIcon = () => (
    <svg {...defaultProps}>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
);

// 통계 아이콘
export const StatisticsIcon = () => (
    <svg {...defaultProps}>
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
);

// 캘린더 아이콘
export const CalendarIcon = () => (
    <svg {...defaultProps}>
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
);

// 가이드 아이콘 (물음표)
export const GuideIcon = () => (
    <svg {...defaultProps}>
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
);

// 사용자/프로필 아이콘
export const UserIcon = () => (
    <svg {...defaultProps}>
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
    </svg>
);

// 로그아웃 아이콘
export const LogoutIcon = () => (
    <svg {...defaultProps}>
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16,17 21,12 16,7" />
        <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
);

// 예약 아이콘 (달력 + 체크)
export const ReservationIcon = () => (
    <svg {...defaultProps}>
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <path d="M9 16l2 2 4-4" />
    </svg>
);

// 관리자 아이콘 (방패)
export const AdminIcon = () => (
    <svg {...defaultProps}>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
);

// 공개 캘린더 아이콘
export const PublicCalendarIcon = () => (
    <svg {...defaultProps}>
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <circle cx="12" cy="16" r="4" fill="none" strokeWidth="1" />
        <path d="M8 16h8" strokeWidth="1" />
        <path d="M12 12v8" strokeWidth="1" />
    </svg>
);

// 특별 메뉴 아이콘 (별)
export const SpecialIcon = () => (
    <svg {...defaultProps}>
        <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
    </svg>
);

// 스튜디오관리 아이콘 (건물 + 기어)
export const StudioManagementIcon = () => (
    <svg {...defaultProps}>
        {/* 건물 */}
        <rect x="3" y="10" width="18" height="12" rx="1" />
        <path d="M3 10l9-8 9 8" />
        <line x1="9" y1="22" x2="9" y2="16" />
        <line x1="15" y1="22" x2="15" y2="16" />
        {/* 기어 (우측 상단) */}
        <circle cx="18" cy="6" r="2" strokeWidth="1.5" />
        <path d="M18 2v1.5M18 8.5V10M14.5 6H16M20 6h1.5M15.2 3.2l1 1M19.8 7.8l1 1M15.2 8.8l1-1M19.8 4.2l1-1" strokeWidth="1" />
    </svg>
);

// 플래시북 아이콘 (책)
export const FlashBookIcon = () => (
    <svg {...defaultProps}>
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        <line x1="9" y1="7" x2="15" y2="7" />
        <line x1="9" y1="11" x2="15" y2="11" />
    </svg>
);

